// extracted by mini-css-extract-plugin
export default {"w-full":"Item_w-full__RW15z","item":"Item_item__5avF7","head":"Item_head__GiSep","active":"Item_active__wLKMj","body":"Item_body__46QvP","title":"Item_title__XTo4E"};